var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-grid-item-container"},[_c('span',{staticClass:"gc-grid-description"},[_vm._v("\n    "+_vm._s(_vm.data.data[_vm.primary[0].dataField])+"\n  ")]),_c('span',{staticClass:"record-secondary gc-grid-code"},[_vm._v(_vm._s(_vm.secondaryItems[0]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }